"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseRepository_1 = tslib_1.__importDefault(require("./BaseRepository"));
const Team_1 = tslib_1.__importDefault(require("../models/Team"));
class TeamRepository extends BaseRepository_1.default {
    constructor() {
        super(...arguments);
        this.model = Team_1.default;
        this.fetchManyQuery = () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/teams/queries/fetchTeams.graphql')));
        this.fetchOneQuery = () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/teams/queries/fetchTeam.graphql')));
    }
    subscriptions() {
        return [
            () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/teams/subscriptions/teamCreated.graphql'))),
            () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/teams/subscriptions/teamUpdated.graphql'))),
            () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/teams/subscriptions/teamDeleted.graphql'))),
        ];
    }
    onTeamCreated(team) {
        this.dataset.push(team);
    }
    onTeamUpdated(team) {
        const idx = this.dataset.all().findIndex(t => t.uuid === team.uuid);
        if (idx < 0) {
            this.dataset.push(team);
        }
        this.dataset.splice(idx, 1, [team]);
    }
    onTeamDeleted(uuid) {
        this.dataset = this.dataset.filter(t => t.uuid !== uuid);
    }
}
exports.default = TeamRepository;
//# sourceMappingURL=TeamRepository.js.map